
import { displayDateFunc, minusStyle, plusStyle, setStyle } from "./TemplateDateTimeControl";

function DatetimeSpinner({...props}) {
    let styleDisplay = setStyle(props.appearance)
    let displayTimes = displayDateFunc(new Date(),props.flag) 
    return (
        <div style={{width: 'calc(var(--font-size) * 2.5)', opacity : '1', paddingLeft:"5px"}}>
            <button 
                type='button'
                style={plusStyle()}
            >
                <i className="fas fa-plus"></i>
            </button>
                <div 
                    style = {styleDisplay} 
                >
                    <b>{displayTimes}</b>
                </div>
            <button 
                type='button' 
                style={minusStyle()}
            >
                <i className="fas fa-minus"></i>
            </button>
        </div>
      );
}

export default DatetimeSpinner;